// src/guide/compte/guide_modifier_infos.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_modifier_infos(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.compte.coordonnees.modifier_infos.nom.titre,
    translations.compte.coordonnees.modifier_infos.nom.texte,
    "#nom",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.coordonnees.modifier_infos.prenom.titre,
    translations.compte.coordonnees.modifier_infos.prenom.texte,
    "#prenom",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.coordonnees.modifier_infos.genre.titre,
    translations.compte.coordonnees.modifier_infos.genre.texte,
    "#genre",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.coordonnees.modifier_infos.poste.titre,
    translations.compte.coordonnees.modifier_infos.poste.texte,
    "#poste",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.compte.coordonnees.modifier_infos.telephone.titre,
    translations.compte.coordonnees.modifier_infos.telephone.texte,
    "#telephone",
    "bottom"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.compte.coordonnees.modifier_infos.valider_modification_infos
      .titre,
    translations.compte.coordonnees.modifier_infos.valider_modification_infos
      .texte,
    "#guide_interne_generale",
    "top"
  );

  tour.start();
}
